<template>
    <div>
    </div>
</template>

<script>
    import Messages from '../modules/Messages';

    export default {
        components: {},
        props: {
            error: {
                type: String
            },
            success: {
                type: String
            },
            warning: {
                type: String
            }
        },
        mounted() {
            if (this.error) {
                Messages.plainTextSimpleError(this.error);
            }
            if (this.warning) {
                Messages.plainTextWarning(this.warning);
            }
            if (this.success) {
                Messages.plainTextSuccess(this.success);
            }
        },
        data() {
            return {};
        }
    };
</script>
